import { Breadcrumbs, Typography } from "@mui/material";
import { useBreadcrumbs } from "hooks/useBreadcrumbs";

export const AppBreadcrumbs = () => {
    const crumbs = useBreadcrumbs();

    return (
        <Breadcrumbs sx={{ color: "#94a3b8", fontSize: 12 }}>
            {crumbs.map((c, i) => (
                <Typography key={i} sx={{ fontSize: 12 }}>
                    {c.label}
                </Typography>
            ))}
        </Breadcrumbs>
    );
};
